// frontend/src/hooks/useStages.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useStages = () => {
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStages = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/stages`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStages(res.data);
      } catch (err) {
        console.error('Failed to fetch stages:', err);
        setStages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStages();
  }, []);

  return { stages, loading };
};